import React, { useEffect, ReactElement } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { CircularProgress, makeStyles } from '@material-ui/core';

import LimberAppBar from './components/LimberAppBar';
import LogoutScreen from './screens/logout/LogoutScreen';
import StatisticsScreen from './screens/statistics/StatisticsScreen';
import { ORGANIZATION_ID_KEY, IS_ADMIN_KEY, Auth0Context } from './utils/auth0';
import PatientsScreen from './screens/patients/PatientsScreen';
import OutcomeMeasuresScreen from
  './screens/outcome-measures/OutcomeMeasuresScreen';
import UserReportsScreen from './screens/user-reports/UserReportsScreen';
import PhysiciansScreen from './screens/physicians/PhysiciansScreen';

export default function App() {
  const {
    isAuthenticated, isLoading, user,
  } = useAuth0() as Auth0Context;

  const routes: Array<ReactElement<typeof Route | typeof Redirect>> = [
    <Route
      path="/logout"
      exact
      component={LogoutScreen}
    />,
  ];
  if (isLoading) {
    routes.push(<Route component={LoadingScreen} />);
  } else if (isAuthenticated && user != null) {
    routes.push(
      <Route
        path="/statistics"
        exact
        component={StatisticsScreen}
      />,
    );
    if (user[ORGANIZATION_ID_KEY] != null) {
      routes.push(
        <Route
          path="/patients"
          exact
          component={PatientsScreen}
        />,
        <Route
          path="/outcome-measures"
          exact
          component={OutcomeMeasuresScreen}
        />,
      );
    } else if (user[IS_ADMIN_KEY]) {
      routes.push(
        <Route
          path="/user-reports"
          exact
          component={UserReportsScreen}
        />,
        <Route
          path="/physicians"
          exact
          component={PhysiciansScreen}
        />,
      );
    }
    routes.push(<Redirect to="/statistics" />);
  } else {
    routes.push(<Route component={LoginRedirect} />);
  }

  return (
    <div>
      <LimberAppBar />
      <Switch>
        {routes}
      </Switch>
    </div>
  );
}

function LoginRedirect() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  useEffect(() => {
    if (!isAuthenticated && !isLoading) loginWithRedirect();
  }, [loginWithRedirect, isAuthenticated, isLoading]);

  return <></>;
}

function LoadingScreen() {
  const classes = useStyles();

  return (
    <div className={classes.loadingContainer}>
      <CircularProgress />
    </div>
  );
}

const useStyles = makeStyles({
  loadingContainer: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
